<template>
  <div class="warehouse-order">
    <a-button
      class="btn-cancel"
      type="primary"
      :disabled="selectedOrders.length === 0"
      @click="cancelOrderMultiple"
    >
      批量取消
    </a-button>
    <a-table
      :columns="WAREHOSERABLE"
      :data-source="orderList"
      size="middle"
      :scroll="{ x: 'calc(700px + 50%)'}"
      :loading="isLoadingTable"
      :pagination="pagination"
      :row-selection="{
        onSelect: handleRowSelect,
        onSelectAll: handleRowSelectAll,
        getCheckboxProps: rowSelect,
        onChange,
        selectedRowKeys: selectedRowKeys
      }"
      @change="handleTableChange"
    >
      <!-- 订单号 -->
      <template slot="unifyOdrNo" slot-scope="text, rowData">
        <p class="textLine">
          <a @click="checkDetail(rowData)">{{ text }}</a>
        </p>
        <p v-if="rowData.crmNumber" class="fontstyle"><span class="wai">外</span>{{ rowData.crmNumber }}</p>
      </template>
      <!-- 订单状态 -->
      <template slot="status" slot-scope="text, rowData">
        <div class="flex align-center">
          <status-tag :type="filterTag(text)" :text="WAREHOSESTATUSTEXT[text]"></status-tag>
          <img v-if="isCargoWarning" class="icon-noice" src="@/assets/img/icon_noice_file.png" alt="">
          <show-more v-if="isCargoWarning" :order-no="rowData.unifyOdrNo" />
        </div>
      </template>
      <!-- 订单类型 -->
      <template slot="scene" slot-scope="text">
        <p>{{ filterScene(text) }}</p>
        <p class="testStyle">{{filterTransport(text)}}</p>
      </template>
      <!-- 货品信息 -->
      <template slot="goosInfo" slot-scope="text, rowData">
        <p>{{filterGoods(rowData)}}</p>
        <p>{{filterWidth(rowData)}}</p>
      </template>
      <!-- 仓货主 -->
      <template slot="customerName" slot-scope="text, rowData">
        <!-- 仓配入库、仓配出库：显示货主名称 -->
        <!-- 调拨
        第一行：显示「发」icon和调出货主名称
        第二行：显示「收」icon和调入货主名称 -->
        <div v-if="rowData.storeCustomerName && rowData.deliverCustomerName">
          <p><span class="tag">发</span>{{ rowData.deliverCustomerName || '' }}</p>
          <p><span class="tag success">收</span>{{ rowData.storeCustomerName || '' }}</p>
        </div>
        <div v-else>
          {{ rowData.storeCustomerName || rowData.deliverCustomerName || '' }}
        </div>
      </template>
      <!-- 仓库 -->
      <template slot="warehouse" slot-scope="text, rowData">
        <p>{{ filterWarehouse(rowData) }}</p>
      </template>
      <!-- 运输地点 -->
      <template slot="startAddress" slot-scope="text, rowData">
        <div v-if="!rowData.orderMsgResList || rowData.orderMsgResList.length <= 0">
          <!-- {{ rowData.endStationName || rowData.startStationName || '--' }} -->
          <p v-if="rowData.endStationName" class="address-txt">
            <span class="endStyle">收</span>
            {{ rowData.endStationName || '' }}
          </p>
          <p v-else-if="rowData.startStationName" class="address-txt">
            <span class="startStyle">发</span>
            {{ rowData.startStationName || '' }}
          </p>
          <p v-else>--</p>
        </div>
        <div v-else>
          <a-tooltip placement="top">
            <template slot="title">
              <p>
                {{
                  (rowData.orderMsgResList[0].consignorProvinceName || '') +
                  (rowData.orderMsgResList[0].consignorCityName || '') +
                  (rowData.orderMsgResList[0].consignorCountyName || '') +
                  (rowData.orderMsgResList[0].consignorAddress || '')
                }}
              </p>
            </template>
            <p class="address-txt">
              <span class="startStyle">发</span>
              {{ rowData.startStationName || '--' }}
            </p>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <p>
                {{getRecipientAddress(rowData)}}
              </p>
            </template>
            <p class="address-txt">
              <span class="endStyle">收</span>
              {{ rowData.endStationName || '--' }}
            </p>
          </a-tooltip>
        </div>
      </template>
      <!-- 订单总金额 -->
      <template slot="orderAmount" slot-scope="text, rowData">
        <span v-if="rowData.ifTransportCancel && rowData.ifWarehouseCancel">0.00</span>
        <span v-else-if="rowData.needTransport && rowData.cost !==null && rowData.warehouseCost !== null">
          {{ filterNumber(rowData.cost, rowData.warehouseCost) }}
        </span>
        <span v-else-if="!rowData.needTransport && rowData.warehouseCost !== null">
          {{ filterNumber(0, rowData.warehouseCost) }}
        </span>
        <span v-else class="order-amount">暂未计算</span>
      </template>
      <!-- 派车信息 -->
      <template slot="dispatchInfo" slot-scope="text, rowData">
        <span v-if="rowData.orderDispatchExtraList.length === 1">
          <p>{{ rowData.orderDispatchExtraList[0].driverName }} {{rowData.orderDispatchExtraList[0].driverPhone}}</p>
          <p>{{ rowData.orderDispatchExtraList[0].licensePlate }}</p>
        </span>
        <span v-else-if="rowData.orderDispatchExtraList.length == 1">
          共派车<a> {{ rowData.orderDispatchExtraList.length }} </a>辆
        </span>
        <span v-else>--</span>
      </template>
        <!-- 下单信息 -->
      <template slot="createTime" slot-scope="text, rowData">
        <p>{{rowData.createUserName}}</p>
        <span>{{text}}</span>
      </template>
      <!-- 操作栏 -->
      <span slot="action" slot-scope="text, rowData">
        <a 
          v-if="showEditButton(rowData.status, rowData.odrChannel, rowData) && !rowData.ifRefuseWaybill"
          v-auth="$_ButtonPermission.WAREHOUSE_EDIT"
          class="action-btn"
          type="link"
          @click="editOrder(rowData, false)">
          编辑
        </a>
        <a 
          class="action-btn"
          type="link"
          @click="editOrder(rowData, true)">
          再来一单
        </a>
        <a
          v-if="showCancelButton(rowData) && !rowData.ifRefuseWaybill"
          v-auth="$_ButtonPermission.WAREHOUSE_CANCEL"
          class="action-btn removeStyle"
          type="link"
          @click="cancelOrder(rowData)"
        >
          取消
        </a>
      </span>
    </a-table>
    <message-box
      v-if="messageFlag"
      :can-cancel-deliver="canCancelDeliver"
      :order-list="closeList"
      @onClose="onClose"
      @onUpdate="onUpdate"
    />
  </div>
</template>

<script>
import moment from 'moment'
import StatusTag from '@/components/tag/StatusTag.vue'
import { WAREHOSERABLE, WarehoseOrderStatus, SCENE, WAREHOSESTATUS, WAREHOSESTATUSTEXT, typeNum } from '../const'
import { fetchOrderList, getWareHouseContract, cancelOrder } from './warehouseapi'
import MessageBox from './MessageBox.vue'
import { getExceptionDetail } from '../api'
import ShowMore from './ShowMore.vue'

// 订单状态 增加草稿，草稿状态可修改
const showStatus = ['DRAFT', 'SUBMITTED', 'EXP_CAL_STATUS', 'PRE_DRAFT']
const showStatusCanCel = ['SUBMITTED', 'EXP_CAL_STATUS', 'DEAL', 'DRAFT', 'TO_BE_DELIVER', 'DELIVERING', 'TO_BE_STORE', 'PRE_DRAFT']

const openApi = 14
const cancanl = 9


export default {
  name: 'WarehouseOrder',
  components: {
    StatusTag,
    MessageBox,
    ShowMore
  },
  data() {
    return {
      WAREHOSERABLE,
      orderList: [],
      selectedOrders: [],
      selectedRowKeys: [],
      WAREHOSESTATUSTEXT,
      closeList: [],
      canCancelDeliver: false, // 可只取消运输
      messageFlag: false,
      isLoadingTable: false,
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pageSize = pageSize
        },
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      warehouseContract: true,
      isCargoWarning: false,
    }
  },
  async created() {
    const { type } = this.$route.query
    const isCargoWarning = type === typeNum.CARGO_WARNING.value
    this.isCargoWarning = isCargoWarning
    this.getOrderList()
    // 获取仓合同
    const {creditCode,customerCode}=this.$store.state.user
    if(!creditCode){
      this.getWarehouseContract(customerCode)
    }
  },
  methods: {
   async getWarehouseContract(customerCode){
      const warehouseContract = await getWareHouseContract({
        cargoOwnerCode: customerCode
      })
      if(!warehouseContract.STORAGE || warehouseContract.STORAGE.length <= 0){
        this.warehouseContract = false
      }
    },
    rowSelect(){
      return ({
          props: {
            disabled: this.tabsValue === 'FINISH',
          },
        })
    },
    filterTag(val){
      if(val === WAREHOSESTATUS.expStatus || val === WAREHOSESTATUS.preDraft){
        return 'err'
      }
      return ''
    },
    // 筛选订单类型
    filterScene(data = ''){
      let text = ''
      switch (data) {
        case SCENE.DELIVER_ONLY:
        case SCENE.DELIVER_TRANSPORT:
            text = '仓配出库'
            break
        case SCENE.STORE_TRANSPORT: 
        case SCENE.STORE_ONLY: 
            text = '仓配入库'
            break
        case SCENE.DELIVER_STORE: 
            text = '仓内调拨'
            break
        case SCENE.DELIVER_TRANSPORT_STORE: 
            text = '仓间调拨'
            break
        default: 
            break
      }

      return text
    },
    filterTransport(data = ''){
      return data.includes('TRANSPORT') ? '' : '不含运输'
    },
    // 货品数量件数筛选
    filterGoods(data){
      let goodsData = null
      if(data.unifyOrderGoodsList && data.unifyOrderGoodsList.length > 0){
        goodsData = data.unifyOrderGoodsList
        const goodsList = []
        goodsData.forEach((e) => {
         if(!goodsList.includes(e.skuCode)){
           goodsList.push(e.skuCode)
         }
        })
        const goodsNumber = goodsList.length
        let num = 0
        goodsData.forEach((e)=>{
          num += e.planAmount
        })
        if(goodsNumber === 1){
          return `${goodsNumber}个货品 共${num}${goodsData[0].skuUnit}`
        }
        return `${goodsNumber}个货品 共${num}件`
      }
      return ''
    },

    // 货品体积数量筛选
    filterWidth(data){
      let goodsData = null
      if(data.unifyOrderGoodsList && data.unifyOrderGoodsList.length > 0){
        goodsData = data.unifyOrderGoodsList
      } else {
        return ''
      }
      let weightTon = 0
      let volume = 0
      goodsData.forEach((e)=>{
        weightTon += e.planWeight
        volume += e.planVolume
      })
      return `共${weightTon.toFixed(3)}kg/${volume.toFixed(3)}M³`
    },
    filterWarehouse(data){
      if(data.deliverWarehouseName && data.storeWarehouseName){
        return `${data.deliverWarehouseName} -> ${data.storeWarehouseName}`
      }
      if(data.deliverWarehouseName){
        return data.deliverWarehouseName
      }
      if(data.storeWarehouseName){
        return data.storeWarehouseName
      }
      return ''
    },
    getRecipientAddress(rowData) {
      const address = rowData.orderMsgResList?.[0]?.orderStationList?.[0] || {};
      return `${address.recipientProvinceName || ''}${address.recipientCityName || ''}${address.recipientCountyName || ''}${address.recipientAddress || ''}`;
    },
    filterNumber(cost, warehouseCost){
      const num = cost * 1 + warehouseCost * 1
      return num.toFixed(2)
    },
    showEditButton(status, odrChannel, row) {
      return (showStatus.includes(status.toString()) && openApi !== odrChannel) || (openApi === odrChannel && status === 'PRE_DRAFT' && row.scene !== SCENE.DELIVER_STORE && row.scene !== SCENE.DELIVER_TRANSPORT_STORE)
    },
    showCancelButton(rowData) {
      // // 待入库 没有运输可以取消
      return showStatusCanCel.includes(rowData.status.toString())
    },
    async getOrderList() {
      const params = {
        pageSize: this.pagination.pageSize,
        page: this.pagination.current
      }
      this.isLoadingTable = true
      try {
        let list = []
        // 轨迹预警处理
        if (this.isCargoWarning) {
          list = []
        } else {
         const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
       const data={
         ...params,
         exceptionType: this.$route.query.type,
            scenes: [
              'TRANSPORT_STORE',
              'DELIVER_ONLY',
              'STORE_ONLY',
              'DELIVER_TRANSPORT',
              'DELIVER_TRANSPORT_STORE',
              'DELIVER_STORE',
            ],
       }
       if(creditCode){
         data.customerCodes=customers.map(item=>item.customerCode)
         data.projectIds=projectIds
       }else{
         data.customerCode=customerCode
         data.projectIds=projectIds
       }
          const detail = await getExceptionDetail(data)
          this.pagination = {
            ...this.pagination,
            // current: detail.page,
            // pageSize: detail.pageSize,
            total: detail.totalRows,
          }
          list = detail.list
        }
        if (list.length) {
          const res = await fetchOrderList({
            sort: "DESC",
            status: ["SUBMITTED","DRAFT","DEAL","TO_BE_DELIVER","DELIVERING",
            "DELIVERED","DISPATCHED","STARTED","SIGNED","PART_SIGNED","REJECTED",
            "TO_BE_STORE","STORING","STORED","FINISHED","CANCELED","EXP_CAL_STATUS","PRE_DRAFT"],
            queryField: {
              unifyNos: list
            }
          }, {
            pageSize: this.pagination.pageSize,
            page: 1
          })
          const orderList = res.records.map(item => {
            // 处理派车信息数据
            const cars = item.dispatchList || []
            const dispatchInfo = {
              firstLine: `${cars[0]?.driverName} ${cars[0]?.driverPhone}`,
              secondLine: cars[0]?.licensePlate,
              carsNum: cars.length
            }
            return {
              ...item,
              key: item.unifyOdrNo,
              statusText: WarehoseOrderStatus[item.status],
              createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
              dispatchInfo,
            }
          })
          this.orderList = orderList
        }
      } finally {
        this.isLoadingTable = false
      }
    },
    onChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleRowSelect(record, selected, selectedRows) {
      this.selectedOrders = selectedRows
    },
    handleRowSelectAll(selected, selectedRows) {
      this.selectedOrders = selectedRows
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.selectedRowKeys = [];
      this.selectedOrders = [];
      this.getOrderList();
    },
    checkDetail(rowData) {
      this.$router.push({
        path: `/order/warehous-detail`,
        query: {
          unifyOdrNo: rowData.unifyOdrNo,
        },
      })
    },
   async editOrder(rowData, oneMoreOrder) {
      await this.getWarehouseContract(rowData.tenantId)
      if(!this.warehouseContract){
        this.$message.warning('没有仓合同！')
        return
      }
      if(oneMoreOrder){
        this.$router.push({
          path: `/order/createOrder`,
          query: {
            odrNo: rowData.unifyOdrNo,
            customerCode:rowData.tenantId,
            productCode: 'warehouse',
            oneMoreOrder: true,
          },
        })
      } else {
        this.$router.push({
          path: `/order/editOrder`,
          query: {
            odrNo: rowData.unifyOdrNo,
            customerCode:rowData.tenantId,
            productCode: 'warehouse'
          },
        })
      }
    },
    cancelOrder(rowData) {
      this.closeList = [rowData.unifyOdrNo]
      let canCanl = true
      if (rowData.status === WAREHOSESTATUS.draft || rowData.status === WAREHOSESTATUS.submitted || rowData.status === WAREHOSESTATUS.expStatus || rowData.status === WAREHOSESTATUS.preDraft) {
        canCanl = false
      }
      // 没有运输
      if(!rowData.orderMsgResList || rowData.orderMsgResList.length <= 0){
        canCanl = false
      }
      // 运输订单，只取消了运输
      if(rowData.orderMsgResList && rowData.orderMsgResList.length > 0 && rowData.orderMsgResList[0].status === cancanl){
        canCanl = false
      }
      this.canCancelDeliver = canCanl
      this.messageFlag = true
    },
    // 订单批量取消
    cancelOrderMultiple() {
      this.closeList = this.selectedOrders.map(item => item.unifyOdrNo)
      this.messageFlag = true
      this.canCancelDeliver = false
    },
    onClose(){
      this.messageFlag = false
    },
    getMessage(list) {
      this.$message.error({
        content: (<div>
        <p>{list.length}个订单取消失败</p>
        {this.getErr(list)}
        </div>),
      });
    },
    getErr(list) {
      return list.map(item => {
        return <p>{item}</p>
      })
    },
    async onUpdate(type) {
      const res = await cancelOrder({
        cancelReason: '货主端取消',
        cancelType: type,
        unifyOdrNos: this.closeList
      })
      try {
        const errList = JSON.parse(res)
        if (errList?.length) {
          if (this.closeList.length === 1) {
            this.$message.error(`取消失败，${errList.join('')}`)
          } else {
            this.getMessage(errList)
          }
        } else {
          this.$message.success('取消成功')
        }
      } catch {
        this.$message.success('取消成功')
      }
      this.messageFlag = false
      this.selectedOrders = []
      this.selectedRowKeys = []
      this.getOrderList()
      this.$emit('getTotal')
    }
  }
}
</script>
<style lang="less" scoped>
.warehouse-order {
  border: 0;
  .tag {
    display: inline-block;
    width: 20px;
    height: 20px;
    color: #fff;
    background: #E89D42;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    margin-right: 4px;
    margin-top: 4px;
    border-radius: 50%;
  }
  .success {
    background: #06b880;
    color: #fff;
    border: none;
  }
  .operations-btns {
    text-align: right;
    margin-bottom: 20px;
  }

  .search-pane {
    padding: 0 30px 15px;
    background-color: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .table-content {
    padding: 12px 30px;
    margin-top: 5px;
    background-color: #fff;
    border-radius: 6px;
  }
  .btn-cancel {
    margin-bottom: 12px;
  }
  .form-row {
    // display: flex;
    // justify-content: space-between;
    .formTitle{
      text-align: right;
      padding-right: 6px;
      width: 100%;
      display: inline-block;
      font-size: 0.8rem;
      line-height: 32px;
    }
  }
  .form-item:last-child {
    margin-right: 0;
  }
  .w-224 {
    // width: 224px;
    min-width: 150px;
  }
  .form-btns {
    display: flex;
    justify-content: flex-end;
    margin-right: 0;
    margin-top: 10px;
  }
  .form-btn {
    margin-left: 20px;
  }
  .address-txt {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .address-txt-min {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .action-btn {
    padding: 0 8px;
    border-right: 1px solid rgba(0, 0, 0, 0.09);

    &:last-child {
      border-right: 0;
    }
  }
  .removeStyle{
    color: #606266;
  }
  .order-amount {
    color: #999999;
  }
  /deep/ .ant-tabs-tab-active{
    font-weight: bold !important;
  }
  /deep/ .ant-table-column-title{
    font-weight: bold;
  }
  .btnhidden{
    visibility: hidden;
  }
  .btnoverhidden{
    display: none;
  }
  .search-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .moreData {
    height: 30px;
    // width: 200px;
    line-height: 50px;
    background-color: #fff;
    font-size: 12px;
    // color: #06b880;
    &:hover {
      cursor: pointer;
    }
  }
  .nextForm{
    margin-top: 15px;
    transition: all ease .2s;
    // overflow: hidden;
  }
  .nextFormActive{
    height: auto;
  }
  .wai{
    display: inline-block;
    width: 18px;
    height: 18px;
    color: #000;
    border: 1px solid #ccc;
    background: #f5f5f5;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
    margin-right: 4px;
    margin-top: 4px;
    border-radius: 50%;
  }
  /deep/ .ant-calendar-picker{
    // width: 250px !important;
    max-width: 100%;
  }
  .fontstyle{
    font-size: 12px;
    color: #999999;
  }
  .textLine{
    text-decoration: underline;
  }
  .icon-noice {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    margin-right: 8px;
  }
  /deep/ .ant-input:placeholder-shown {
      font-size: 12px;
  }
  .noAuthority{
    text-align: center;
    color: #ccc;
    background: #fff;
    height: calc(100vh - 200px);
    line-height: calc(100vh - 200px);
  }
  .testStyle{
    font-size: 12px;
    color: #ccc;
  }
  .startStyle{
    display: inline-block;
    width: 20px;
    height: 20px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    background-color: #E89D42;
    border-radius: 50%;
  }
  .endStyle{
    display: inline-block;
    width: 20px;
    height: 20px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    background-color: #06b880;
    border-radius: 50%;
  }
  .divmaks{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: no-drop;
  }
}

</style>